<div class="select-container" [id]="uniqueId">
  <div
    class="custom-select"
    [ngClass]="{ 'open-dropdown': openDropdown, error: error }"
    (click)="toggleDropdown()"
  >
    <div class="display-icon" *ngIf="!loading">
      <img
        *ngIf="bindIcon && selectedObject"
        class="icon"
        [src]="selectedObject[bindIcon]"
        alt=""
      />
      <span *ngIf="translateKey && selectedObject">
        {{ translateKey + selectedObject[bindName] | translate }}
      </span>
      <span *ngIf="!translateKey && selectedObject">
        {{ selectedObject[bindName] }}
      </span>
      <span [hidden]="!selectedObject" class="placeholder-select">
        {{ placeholder }}
      </span>
    </div>

    <div class="span-ellipsis" *ngIf="loading">
      <span class="placeholder-select">
        {{ "Loading" | translate }}
      </span>
    </div>

    <tui-svg [class.open]="openDropdown" src="tuiIconChevronDown"></tui-svg>
  </div>
  <div
    class="options-container"
    [ngClass]="{ absolute: showAbsolute }"
    *ngIf="openDropdown"
  >
    <div class="options-scroll">
      <div *ngFor="let item of dataArray; let last = last">
        <div
          (click)="selectOption(item)"
          [ngClass]="
            selectedObject && selectedObject[bindValue] === item[bindValue]
              ? 'selected-option'
              : 'option'
          "
          [attr.aria-selected]="
            selectedObject && selectedObject[bindValue] === item[bindValue]
          "
        >
          <div class="option-content">
            <img class="icon" *ngIf="bindIcon" [src]="item[bindIcon]" alt="" />

            {{
              translateKey
                ? (translateKey + item[bindName] | translate)
                : item[bindName]
            }}
          </div>

          <img
            *ngIf="
              selectedObject && selectedObject[bindValue] === item[bindValue]
            "
            src="assets/icons/solid_check.webp"
            alt="Check Icon"
            loading="lazy"
          />
        </div>
        <div class="split-option" *ngIf="!last"></div>
      </div>
    </div>
  </div>
</div>
